import { render, staticRenderFns } from "./LibraryMain.vue?vue&type=template&id=0f126032"
import script from "./LibraryMain.vue?vue&type=script&lang=js"
export * from "./LibraryMain.vue?vue&type=script&lang=js"
import style0 from "./LibraryMain.vue?vue&type=style&index=0&id=0f126032&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports